import React, {forwardRef, useContext} from "react";

import {View, Text}  from 'react-native'

import cores from '../util/cores'

import {estilos} from '../util/estilos'

import * as texto from '../util/texto'

import Botao from '../componentes/Botao'

import contexto from '../util/contexto'



const BarraTitulo = forwardRef((props, ref) => {


	const {valorContexto} = useContext(contexto);

	return (
        <View style={{
					backgroundColor: cores.barra_status,
					padding: 8,
					margin:0,
					borderBottomColor: cores.azul,
					borderBottomWidth: 1,
				}}>
                {(texto.isNotBlanck(props.titulo))?
					(props.voltar!=null?
						<View style={estilos.grade}>
							<View style={[estilos.coluna, {alignItems:'flex-start'}]}>
								<Botao
									acao={()=>props.voltar()}
									texto="voltar"/>
							</View>
							<View style={estilos.coluna_tripla}>
								<View style={{alignItems:'center'}}>
									<View style={{marginTop:8}}/>   	
									<Text style={[estilos.rotulo_titulo, {color: cores.fonte_clara}]}>{props.titulo}</Text>
								</View>
							</View>
							<View style={estilos.coluna}>
								
								{!props.ocultarPontos && 
									<View style={{alignItems:'flex-end'}}>
										<View style={{marginTop:8}}/>  
										<Text style={[estilos.rotulo_titulo, {color: cores.fonte_clara}]}>{valorContexto.saldoAtual.toString()} pts</Text>
									</View>
								}
							</View>
						</View>:
						<View style={{alignItems:'center'}}>
							<Text style={[estilos.rotulo_titulo, {color: cores.fonte_clara}]}>{props.titulo}</Text>
						</View>):
					(props.children!=null)?(props.children):(<View></View>)
				}	
        </View>
    )
});

export default BarraTitulo;


